<template>
  <div class="topnav-box">
    <nav id="topnav" class="topnav width-full pt-4">
      <Container>
        <div class="d-flex flex-items-center flex-wrap">

          <!-- nav -->
          <div class="main-nav flex-auto d-flex flex-items-center flex-wrap mb-jcc">

            <router-link
              :to="'/'"
              class="d-inline-block d-flex flex-items-center ml-4"
            >
              Home
            </router-link>

          </div>
          
          <!-- account -->
          <div :key="web3.account" class="account-box pc-ml-auto mb-ml-auto mb-mr-auto">
            <template v-if="$auth.isAuthenticated && !wrongNetwork">
              <button
                @click="modalOpen = true"
                :loading="loading"
                class="ui-btn size-sm outlined"
              >
                <Avatar :address="web3.account" size="16" class="mb-none mr-2 ml-n1" />
                <span v-if="web3.name" v-text="web3.name" />
                <span v-else v-text="_shorten(web3.account)" />
              </button>
            </template>

            <button
              v-if="web3.injectedLoaded && wrongNetwork"
              class="text-red ui-btn size-sm outlined"
            >
              <Icon name="warning" class="ml-n1 mr-1 v-align-middle" />
              {{lg('',{
                en: 'Wrong network',
                zh: '网络错误',
              })}}
            </button>

            <button
              class="ui-btn size-sm outlined"
              v-if="showLogin"
              @click="modalOpen = true"
              :loading="loading"
            >
              {{lg('',{
                en: 'Connect wallet',
                zh: '连接钱包',
              })}}
            </button>

            <!-- about -->
            <!-- <button  @click="modalAboutOpen = true" class="ui-btn outlined ml-2">
              <span v-text="'?'" class="ml-n1 mr-n1" />
            </button> -->
          </div>
        </div>

        <ModalAccount
          :open="modalOpen"
          @close="modalOpen = false"
          @login="handleLogin"
        />
        <ModalAbout :open="modalAboutOpen" @close="modalAboutOpen = false" />

        <!-- <hr class="colored"> -->
      </Container>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex';


export default {
  data() {
    return {
      // jj 按钮loading效果
      loading: false,
      
      modalOpen: false,
      modalAboutOpen: false
    };
  },
  computed: {
    wrongNetwork() {
      // console.log('======wrongNetwork======')
      // console.log(this.config.chainId,this.web3.injectedChainId)
      return this.config.chainId !== this.web3.injectedChainId;
    },
    showLogin() {
      return (
        (!this.$auth.isAuthenticated && !this.web3.injectedLoaded) ||
        (!this.$auth.isAuthenticated && !this.wrongNetwork)
      );
    },
  },
  methods: {
    ...mapActions(['login']),

    async handleLogin(connector) {
      this.modalOpen = false;
      this.loading = true;
      await this.login(connector);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scope>
  @import '@/assets/css/vars.scss';

  .topnav-box{
    .topnav{
      .main-nav{
        a{
          line-height: 40px;
          font-size: 20px;
        }
      }
    }
  }
  // hr.colored{
  //   margin: 0;
  //   border: none;
  //   width: 100%;
  //   height: 1px;
  //   opacity: 0.5;
  //   background-color: $c_border;
  //   margin-top: 30px;
  // }
</style>
